import { Component, Input } from '@angular/core';
import { PATHS } from 'models/bary-paths.model';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-sidebar-footer',
  templateUrl: './bary-sidebar-footer.component.html',
  styleUrls: ['./bary-sidebar-footer.component.scss'],
})
export class BarySidebarFooterComponent {
  @Input() isModerator = false;

  protected readonly PATHS = PATHS;
  protected readonly FaDirectiveEnum = FaDirectiveEnum;

  public callSupport(): void {
    window!.top!.location.href = 'mailto:assistance@bary.app';
  }
}
